<template>
  <nt-auth-template>
    <div></div>
  </nt-auth-template>
</template>

<script>
import store from '@/store'
import NtAuthTemplate from '@/components/Utils/NtAuthTemplate'

export default {
  components: {
    NtAuthTemplate
  },
  mounted () {
    this.logout()
  },
  methods: {
    logout () {
      store.dispatch('App/logout').then(response => {
        store.commit('App/setInfo', null)
        window.location = '/'
      })
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
